import * as React from 'react';

export default ({ onSelectTile, tileLayers }: {
  tileLayers: ITileLayer[];
  onSelectTile: (id: string) => void;
}) => {
  return (
    <div>
      {tileLayers.map(item => {
        return (
          <label
            key={item.id}
            onClick={() => onSelectTile(item.id)}
          >
            <input type="radio" name="mapTile"  defaultChecked={item.id === 'tiles-openStreetMap-layer'}/>
            {item.label}
          </label>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/SelectMapTileView.tsx